import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

const CustomerSupportCodeTooltip = (): React.ReactElement => {
  const translate = useTranslate()
  return (
    <Tooltip openLeft={false}>
      {translate(
        '${supportCode} is a one-time, 6-digit security code that helps customer service verify that you are the owner of the virtual card.',
        {
          supportCode: (
            <span
              css={css`
                font-family: ${styleConstants.fontFamilies.medium};
              `}
            >
              {translate('Customer support code')}
            </span>
          ),
        },
      )}
    </Tooltip>
  )
}

export default CustomerSupportCodeTooltip
